// extracted by css-extract-rspack-plugin
module.exports =  {"group":"OptionGroup-t9jh__group","full-width":"OptionGroup-rq1U__full-width","item":"OptionGroup-vgT5__item","item--active":"OptionGroup-nAbT__item--active"};